import { composeWithDevTools } from '@redux-devtools/extension';
import { type Store, type UnknownAction, applyMiddleware, createStore } from 'redux';
import { thunk } from 'redux-thunk';
import { rootReducer } from './reducers';
import type { RootState } from './types/redux';

const composeEnhancers = composeWithDevTools({
  name: 'QueryEditor', // Separate DevTools instance
  trace: true,
  traceLimit: 25,
});

// Persistor interface for compatibility
export interface Persistor {
  pause: () => void;
  persist: () => void;
  purge: () => Promise<void>;
  flush: () => Promise<void>;
  getState: () => { bootstrapped: boolean };
  subscribe: (listener: () => void) => () => void;
}

// Export with query-editor specific names (persistence disabled for now)
export const queryEditorStore: Store<RootState, UnknownAction> = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk))
);

// Create a no-op persistor for compatibility
export const queryEditorPersistor: Persistor = {
  pause: () => {},
  persist: () => {},
  purge: () => Promise.resolve(),
  flush: () => Promise.resolve(),
  getState: () => ({ bootstrapped: true }),
  subscribe: () => () => {},
};

// Also export with original names for backwards compatibility within the feature
export const store = queryEditorStore;
export const persistor = queryEditorPersistor;
